import { Component, Inject, signal, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StandardButtonComponent } from "../../standard-button/standard-button.component";


@Component({
    selector:'app-success-popup',
    standalone:true,
    imports: [StandardButtonComponent],
    templateUrl: './success-popup.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls:['./success-popup.component.scss']
})
export class SuccessPopup{
    constructor(private dialogRef:MatDialogRef<SuccessPopup>,@Inject(MAT_DIALOG_DATA) public dialogData:any){
        this.initializeData();
    
      }
      message=signal<string>('');
      submessage=signal<string>('');
    
      initializeData(){
        if(!this.dialogData) return;
        console.log(this.dialogData);
        this.message.set(this.dialogData.message);
        this.submessage.set(this.dialogData.submessage);
      }
    
      closePopup(){
        this.dialogRef.close();
    
      }
}